<template>
    <div id="logout">
        <patternlib-spinner spin/>
    </div>
</template>

<script>
import { useServices } from '../services/useServices';
import { useAuth } from '../stores/authStore';

export default {
    methods: {
        async logout() {
            const services = useServices()
            const authStore = useAuth()

            try {
                authStore.clearUserData()
                await services.$auth.logout()
                console.log("Logout succeded!")
            }
            catch (error) {
                console.log(error)
            }
        }
    },
    async created() {
        await this.logout()
    }
}
</script>

<style lang="scss" scoped>
#logout {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>